<template>
    <div>
         <DxPopup
            :visible="this.isVisible"
            :drag-enabled="false"
            :close-on-outside-click="false"
            :show-title="true"
            :show-close-button="false"
            :width="800"
            :height="500"
             title="Ανέβασμα Εγγράφων Πληρωμής"
             >                        
            <div class="row">
               <DxDataGrid  id="gridContainer" :data-source="paymentDocuments" key-expr="Id"  :show-borders="true" :show-row-lines="true" :row-alternation-enabled="true">
                    <DxColumn caption="Τύπος Εγγράφου" data-field="DocumentDto.Description"/>
                    <DxColumn caption="Εχει Ανέβει" data-field="HasBeenUploaded" data-type="boolean" width="100px"/>
                    <DxColumn caption="Ημερομηνία" data-field="LastUploadDate" format="dd/MM/yyyy hh:mm:ss" data-type="date" width="150px"/>
                    <DxColumn data-field="DocumentDto.Id"  cell-template="cellTemplate" caption=""/>                        
                    <template #cellTemplate="{ data }">
                        <div>                        
                        <DxFileUploader :ref="fileUploaderRef" :multiple="false" accept="image/*"   upload-mode="instantly"                          
                           @value-changed="onValueChanged($event,data)"
                           @uploaded="(e) => onUploaded(e, data)" @upload-error="onUploadError"/>                        
                        </div>
                    </template>                                        
               </DxDataGrid>
            </div>         
            <div class="row">
                <DxButton  text="Επιστροφή" type="danger" styling-mode="contained" @click="onClosePopup" />
            </div>            
        </DxPopup>    
    </div>
</template>


<script>

 import {DxButton} from 'devextreme-vue/button';
 import {DxFileUploader } from "devextreme-vue/file-uploader";
 import {DxPopup} from 'devextreme-vue/popup';
 import mainService from '../../services/mainService';
 import {DxDataGrid,DxColumn} from 'devextreme-vue/data-grid';  
 import notify from 'devextreme/ui/notify';   

const fileUploaderRef = "fu";

export default {
        props: ['paymentId','isVisible'],
        components: {                  
           DxPopup,DxDataGrid,DxColumn,DxFileUploader,DxButton
        },
        data () {
            return {
                fileUploaderInstance:null,
                paymentDocuments:null,
                fileUploaderRef,    
                askedUser:0             
            }
        },         
        computed:{
            fileUploader: function() {
                return this.$refs[fileUploaderRef].instance;
            },
        },
        methods:{
            async getPaymentDocuments(){
                this.paymentDocuments=[];             
                const res = await mainService.get(`/PaymentDocuments/GetPaymentDocuments?paymentId=${this.paymentId}`);                   
                this.paymentDocuments = res.data.PaymentDocumentDtos; 
                this.askedUser = res.data.askedUser;
            },
            onClosePopup(){
                  this.$emit('emit-close-popup',{});   
            },
            onValueChanged(e,data) {                   
                var url = `${this.$PaymentController}/UploadPaymentDocuments?paymentId=${this.paymentId}&paymentDocumentId=${data.data.Id}
                           &paymentDocumentDocumentId=${data.data.DocumentId}&askedUser=${this.askedUser}`;                               
                e.component.option("uploadUrl", url);                                                           
            },    
            onUploaded(e, cellInfo) {
                 notify("Το αρχείο ανέβηκε", 'success', 2000);
                 this.getPaymentDocuments();
            },
            onUploadError(e) {                
                let xhttp = e.request;
                if(xhttp.status === 400){
                    e.message = e.error.responseText;
                    notify("Πρόβλημα κατά το ανέβασμα", 'error', 2000);
                }
                if(xhttp.readyState === 4 && xhttp.status === 0) {
                    e.message = "Connection refused";
                }           
            }
        },

        async mounted(){                                  
            await this.getPaymentDocuments();
        }            
    }
</script>